export default __webpack_public_path__ + "static/media/cizma9.30413be1.jpg";